import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IOyanaResponse, useGetPersonalDataMutation } from '../../services/me.service';
import { useGetObjectUrlMutation } from '../../services/file.service';
import { saveOyanaPersonaData } from '../../features/me/me-slice';
import { useIsLoggedIn, useLogout } from './useIsLoggedIn';
import { RootState } from '../../store';

export function useOyana(): IOyanaResponse | undefined {
  const [getPersonalData, { data }] = useGetPersonalDataMutation();
  const [getObjectUrl] = useGetObjectUrlMutation();
  const dispatch = useDispatch();
  const isLoggedIn = useIsLoggedIn();
  const [logout] = useLogout();
  const {
    oyana: { me }
  } = useSelector((state: RootState) => state);

  useEffect(() => {
    if (isLoggedIn && !me.id) {
      getPersonalData({});
    }
  }, [isLoggedIn, me.id]);

  useEffect(() => {
    if (data && !data.id) {
      logout();
      return;
    }

    if (data) {
      dispatch(saveOyanaPersonaData(data));
      if (data.profileImageThumbnail && data.profileImageThumbnail.length > 0) {
        getObjectUrl({ url: data.profileImageThumbnail })
          .unwrap()
          .then(res => {
            const { url } = res;
            const payload = { ...data, profileImageThumbnail: url };
            dispatch(saveOyanaPersonaData(payload));
          });
      }
    }
  }, [data]);

  const cachedOyana = useMemo(() => {
    if (me.id && me.id.length > 0) {
      return me;
    }
    if (data && data.id && data.id.length > 0) {
      return data;
    }
    return undefined;
  }, [data, me]);

  return cachedOyana;
}
